import React, { useEffect, useState } from 'react'
import { _FORM_ITEM_LAYOUT, _TAIL_FORM_ITEM_LAYOUT, TWO_BTN_TAIL_FORM_ITEM_LAYOUT } from '../../../../constants';
import { CancelDeleteContainer, ModalContentWrapper, SaveBtnContainer, StyledForm, StyledSaveBtn } from './style';
import { Button, Form, Input, Modal, Spin } from 'antd';
import { useDeleteTag } from '../../../../hooks/common/useTags';
import { TagFormProps } from './type';

const TagsForm: React.FC<TagFormProps> = ({
  onBack,
  onSubmit,
  onReset,
  defaultValues,
  loading,
  isEdit
}) => {
  const [form] = StyledForm.useForm();
  const [confirmDelete, setConfirmDelete] = useState<boolean>(false);
  const { delete: deleteTag, loading: deleteTagLoading } = useDeleteTag();

  const onFinish = async (values: any) => {
    onSubmit(values);
  };

  const handleOnBack = () => {
    onBack();
  };

  const handleOnDelete = async () => {
    // const res = await deleteProfessionalUser(defaultValues?.id);
    console.log(defaultValues?.id);
  }

  useEffect(() => {
    form.setFieldsValue({
      id: defaultValues?.id,
      name: defaultValues?.name,
    });
  }, [defaultValues, form]);

  return (
    <>
      <StyledForm
        {..._FORM_ITEM_LAYOUT}
        form={form}
        name="tags_form"
        onFinish={onFinish}
        initialValues={{}}
        style={{ marginTop: '1rem' }}
        scrollToFirstError
      >
        <Form.Item hidden name='id'>
          <Input />
        </Form.Item>
        <Form.Item
          labelAlign="left"
          name="name"
          label="Name"
          rules={[
            {
              required: true,
              message: 'Name can\'t be blank',
            },
          ]}
        >
          <Input />
        </Form.Item>
        <StyledForm.Item {...TWO_BTN_TAIL_FORM_ITEM_LAYOUT}>
          <SaveBtnContainer>
            {!isEdit && (
              <Button onClick={handleOnBack} type="text">
                Back
              </Button>
            )}
            <StyledSaveBtn type="primary" htmlType="submit" loading={loading}>
              Save
            </StyledSaveBtn>
          </SaveBtnContainer>
          {isEdit && (
            <CancelDeleteContainer>
              <Button onClick={() => setConfirmDelete(true)} type="primary" style={{ background: 'red' }}>
                Delete
              </Button>
              <Button onClick={handleOnBack} type="text">
                Back
              </Button>
            </CancelDeleteContainer>
          )}
        </StyledForm.Item>
      </StyledForm>
      <Modal
        title='Delete Tag'
        open={confirmDelete}
        onOk={handleOnDelete}
        onCancel={() => setConfirmDelete(false)}
        width={400}
      >
        <ModalContentWrapper>
          {deleteTagLoading ? (
            <Spin />
          ) : (
            <p>Are you sure you want to delete the tag?</p>
          )}
        </ModalContentWrapper>
      </Modal>
    </>
  );
};

export default TagsForm;